import NearBeMap from './NearBeMap'

export default NearBeMap
